module.exports = __webpack_public_path__ + "static/roksolana-87727d10a2be991400edff4908e95e78.svg";